import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoHangPhanAnh } from 'src/app/shared/LoHangPhanAnh.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class LoHangPhanAnhService extends BaseService{

    DisplayColumns001: string[] = ['ID', 'ParentID', 'Name', 'DangKy'];
        
    List: LoHangPhanAnh[] | undefined;
    ListFilter: LoHangPhanAnh[] | undefined;
    FormData!: LoHangPhanAnh;

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "LoHangPhanAnh";
    }
}

